import { render } from "./ReqLead.vue?vue&type=template&id=0ff1f35a"
import script from "./ReqLead.vue?vue&type=script&lang=js"
export * from "./ReqLead.vue?vue&type=script&lang=js"

import "./ReqLead.vue?vue&type=style&index=0&id=0ff1f35a&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__